export default __webpack_public_path__ + "static/media/bg_home_mobile.1068618f.jpg";